import React from "react";
import { useTranslation } from "react-i18next";
import { FiUsers, FiXCircle } from "react-icons/fi";
import { SurveyOutcomeCard } from "pages/SurveyComplete/SurveyOutcomeCard";

export const UserQuotafull = ({ isHmacFailed }: any) => {
  const { t } = useTranslation();

  return (
    <SurveyOutcomeCard
      tone={isHmacFailed ? "danger" : "warning"}
      icon={isHmacFailed ? FiXCircle : FiUsers}
      title={isHmacFailed ? t("page.surveysecurityterminate.internal") : t("page.quotafull.SurveyHave")}
      actions={
        <a href="/join-now" className="zs-btn zs-btn-primary zs-btn-lg zs-btn-block">
          {t("page.quotafull.MySurveys")}
        </a>
      }
    >
      <p>
        {t("page.terminate.Explore")}
      </p>
      <p className="rounded border border-line bg-surface-2 px-4 py-3 text-[13px] text-ink-3">
        {t("page.terminate.case")}
      </p>
    </SurveyOutcomeCard>
  );
};
